import styled from '@emotion/styled';
import ModalDesktop, {
  ModalDesktopProps
} from '@portalterreno/react-ui-core/ModalDesktop';

export type StyledModalDesktopProps = ModalDesktopProps;

const StyledModalDesktop = styled(ModalDesktop)<StyledModalDesktopProps>({
  maxWidth: 600
});

export default StyledModalDesktop;
